import * as pdfjsLib from "pdfjs-dist";

// Set the workerSrc for PDF.js
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const convertPdfToImages = async (file) => {
  const images = [];
  const fileURL = URL.createObjectURL(file);

  try {
    const pdfDocument = await pdfjsLib.getDocument(fileURL).promise;
    const numPages = pdfDocument.numPages;

    for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
      const page = await pdfDocument.getPage(pageNumber);
      const scale = 1.5;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({ canvasContext: context, viewport }).promise;

      const image = canvas.toDataURL();
      images.push(image);
    }

    return await mergeImagesIntoSingle(images); // return merged image
  } catch (error) {
    console.error("PDF to image conversion failed:", error);
    return null;
  }
};

const mergeImagesIntoSingle = async (imageList) => {
  if (imageList.length === 0) return null;

  const loadedImages = await Promise.all(
    imageList.map((src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.src = src;
      });
    })
  );

  const totalWidth = Math.max(...loadedImages.map((img) => img.width));
  const totalHeight = loadedImages.reduce((sum, img) => sum + img.height, 0);

  const canvas = document.createElement("canvas");
  canvas.width = totalWidth;
  canvas.height = totalHeight;
  const ctx = canvas.getContext("2d");

  let yOffset = 0;
  for (const img of loadedImages) {
    ctx.drawImage(img, 0, yOffset);
    yOffset += img.height;
  }

  return canvas.toDataURL(); // Return the merged image as base64
};

export default convertPdfToImages;
